import { TAppVersion } from '~/src/Entities/App/App.Types'

export interface T_APP_CONFIG_REDUCER {
  appVersion?: TAppVersion
}

export const INITIAL_STATE: T_APP_CONFIG_REDUCER = {}
